module.exports = __webpack_public_path__ + "img/company44.29cc8748.png";